import { Wrench, Package, Sparkles, Check, ArrowRight } from "lucide-react";

const services = [
  {
    id: "pose-seule",
    badge: "Main d'œuvre",
    icon: Wrench,
    title: "Pose seule",
    price: "à partir de 80€",
    desc: "Vous fournissez vos composants, je m'occupe du montage complet, câblage propre et tests de stabilité.",
    points: [
      "Montage complet (CPU, GPU, RAM, stockage, refroidissement)",
      "Câble management soigné",
      "Stress test et vérification des températures",
      "Installation Windows possible sur demande",
      "Devis fixe à l'avance — prix bloqué",
    ],
  },
  {
    id: "cle-en-main",
    badge: "Sur mesure",
    icon: Package,
    title: "PC clé en main",
    price: "selon votre budget",
    desc: "Donnez-moi votre budget et votre usage, je sélectionne les meilleurs composants chez mes fournisseurs et je vous livre un PC prêt à jouer.",
    points: [
      "Configuration optimisée selon votre usage",
      "Devis détaillé envoyé par écrit",
      "Composants sourcés chez fournisseurs sérieux",
      "Livraison soignée à domicile",
      "Testé et validé avant livraison",
    ],
    featured: true,
  },
  {
    id: "nettoyage",
    badge: "Maintenance",
    icon: Sparkles,
    title: "Nettoyage complet PC gamer",
    price: "à partir de 30€",
    desc: "Votre PC chauffe, ralentit ou souffle plus fort qu'avant ? Un grand nettoyage redonne 100% des perfs et prolonge sa durée de vie.",
    points: [
      "Démontage et dépoussiérage minutieux (ventilateurs, radiateurs, alimentation)",
      "Changement de la pâte thermique CPU & GPU (Arctic MX-4 / Kryonaut)",
      "Nettoyage des filtres à poussière et du boîtier",
      "Re-management des câbles si nécessaire",
      "Optimisation Windows (démarrage, services, drivers à jour)",
      "Test de températures avant/après remis par écrit",
    ],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-violet-400">
            // Services
          </p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Trois formules, une même{" "}
            <span className="text-violet-400">exigence</span>.
          </h2>
          <p className="mt-4 text-zinc-400">
            Montage, configuration sur mesure ou grand nettoyage : vous avez un
            interlocuteur unique du premier message jusqu'à la livraison.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`reveal group relative rounded-2xl p-7 sm:p-9 transition-all duration-300 hover:-translate-y-1 ${
                  s.featured
                    ? "gradient-border shadow-violet-soft hover:shadow-violet"
                    : "bg-zinc-900/40 border border-white/10 hover:border-violet-400/40"
                }`}
              >
                {s.featured && (
                  <div className="absolute -top-3 right-6 rounded-full bg-violet-600 px-3 py-1 text-[10px] font-mono uppercase tracking-[0.18em] text-white shadow-violet">
                    Recommandé
                  </div>
                )}

                <div className="flex items-start justify-between">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-violet-500/40 bg-violet-500/10">
                    <Icon className="h-6 w-6 text-violet-300" />
                  </div>
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                    {s.badge}
                  </span>
                </div>

                <h3 className="mt-6 font-display text-2xl sm:text-3xl font-bold">
                  {s.title}
                </h3>
                <p className="mt-2 font-mono text-sm text-violet-300">
                  {s.price}
                </p>
                <p className="mt-4 text-zinc-400 leading-relaxed">{s.desc}</p>

                <ul className="mt-6 space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-sm">
                      <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-violet-500/15 border border-violet-500/40">
                        <Check className="h-3 w-3 text-violet-300" />
                      </span>
                      <span className="text-zinc-300">{p}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  data-testid={`service-cta-${s.id}`}
                  className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-violet-300 hover:text-violet-200 transition-colors"
                >
                  Demander un devis pour cette formule
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
